import { BG_COLOR_REGEX_PATTERN } from '../constants';

/**
 * NOTE: This may no longer be needed after moving to use uik:Card component
 * This method is a temporary workaround to replace background color in className with custom background color
 * (custom background color takes precedence over background color specified in className)
 * Assumes that no other background related properties are specified in className
 * This applies to the following container templates:
 * - dashify:Card
 * - dashify:CardWithEditProps
 * - dashify:CardWithTitle
 * @param className Tailwind className string
 * @param customBgColor custom background color to use
 */
export const applyCustomBgColor = (className: string | undefined, customBgColor: string | undefined): string => {
  // use customBgColor if specified
  if (customBgColor && customBgColor.length > 0) {
    if (className && className.length > 0) {
      return className.includes('bg-')
        ? className.replace(BG_COLOR_REGEX_PATTERN, `bg-${customBgColor}`) // replace bg property in className with customBgColor
        : `${className} bg-${customBgColor}`; // include customBgColor in className
    }
    return `bg-${customBgColor}`;
  }
  // use bg-inherit if customBgColor and className are not specified
  if (!className || className.length === 0) {
    return `bg-inherit`;
  }

  // if no customBgColor specified, use className if it includes bg property; otherwise use bg-inherit
  return className.includes('bg-') ? className : `bg-inherit ${className}`;
};
